<template>
  <div>
    <v-card outlined class="marco">
      <v-card-subtitle>
        <h4><strong>{{ $t('page.sectionEditor.keytime') }}</strong></h4>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-switch
              compact
              v-model="Section.raceSectionChecks[0].isRecalculateKeyTime"
              dense 
              hide-details="auto"
              color="blue"
              class="includeFlagSwitch mt-0"
              :true-value="1"
              :false-value="0"
              :label="$t('page.sectionEditor.recalculate_keytime')"
              @change="updateField('isRecalculateKeyTime', Section.raceSectionChecks[0].isRecalculateKeyTime)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-select
              v-model="Section.raceSectionChecks[0].checkType"
              :items="timeCheckTypeItems" dense
              :label="$t('page.sectionEditor.time-check-type')"
              outlined 
              @change="updateField('checkType', Section.raceSectionChecks[0].checkType)"
              :rules="[ (v) => $inputRules({ value: (v || '') }, 'filled') || $t('page.sectionEditor.errors.time-check-type-required') ]"
              :no-data-text="$t('common.no_data')"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <DateTimeText 
                :label="$t('page.sectionEditor.keytime')"
                :time="Section.raceSectionChecks[0]"
                @updateField="updateFieldCheck"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <br />
    <!-- EARLY PENALTIES -->
    <EarlyPenalties ref="earlyPenalty" :Section="Section" />
    

    <br />
    <!-- LATE PENALTIES -->
    <LatePenalties ref="latePenalty" :Section="Section" />
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import EarlyPenalties from "@/components/section-editor/time-check/EarlyPenalties.vue";
import LatePenalties from "@/components/section-editor/time-check/LatePenalties.vue";
import DateTimeText from '@/components/section-editor/time-check/DateTimeText.vue';

export default {
  mixins: [apiCalls], //for api redundant operations
  components: { DateTimeText, EarlyPenalties, LatePenalties },
  props: ["Section"],
  data() {
    return {
      menu: null,
      time: false,
      modal: false,
      timeCheckTypeItems: [
        {
          text: this.$t("page.sectionEditor.start"),
          value: "in"
        },
        {
          text: this.$t("page.sectionEditor.regular"),
          value: "out"
        }
      ],      
    };
  },
  computed: {
    Check() {
      return this.Section.raceSectionChecks[0];
    }
  },
  mounted() {},
  methods: {
    updateField(field, value) {
      if (value == "" && value != 0) return false;
      let valueReal = value;
      if(field == 'keyTime') valueReal = this.findKeyTime(value);

      let formData = {
        sectionId: this.Section.id,
        checkId: this.Check.id,
        field,
        value: valueReal
      };
      this.$store.dispatch('addSectionTimeCheckCheckUpdateAction', formData);
    },
    updateFieldCheck({ item }) {
      this.updateField('keyTime', item);
    },
    findKeyTime(value) {
        if(typeof value == 'object') {
          if(Object.prototype.hasOwnProperty.call(value,'keyTime')) {
            value = value.keyTime;
            return value;
          } else {
            for (const property in value) {
              if(this.findKeyTime(value[property])) {
                value = this.findKeyTime(value[property]);
                return value;
              }
            }
          }
        }
        return false;
    }
   }
};
</script>

<style lang="scss" scoped>
.pl47 {
  padding-left: 47px;
}
.mt8n {
  margin-top: -8px;
}
.mt30n {
  margin-top: -30px;
}
.mt45n {
  margin-top: -45px;
}
.marco {
  padding: 0px 10px;
}
</style>